module.exports = __webpack_public_path__ + "static/media/operational-new.af40369b.png";